import { Box, IconButton } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import noop from 'lodash/noop';
import { VyDatePicker } from '../../../../components/new-design/date-picker/VyDatePicker';
import { VyTableToolbar } from '../../../../components/new-design/table/vy-table-toolbar/vy-table-toolbar';
import {
  VyTableFilter,
  type FilterLineType,
} from '../../../../components/new-design/vyTableFilter';
import {
  reportDatePickerSlotProps,
  reportFilterButtonWrapperSx,
  reportIconButtonSx,
  reportSearchContainerSx,
  reportSearchInputSx,
} from '../../reports-components/report-toolbar-styles';
import { JOURNAL_ENTRIES_FILTER_FIELDS } from '../utils/journal-entries-filter-fields';

type Props = {
  month: Date | null;
  onMonthChange: (date: Date | null) => void;
  customerSearch: string;
  onCustomerSearchChange: (value: string) => void;
  filters: FilterLineType[];
  onFiltersChange: (filters: FilterLineType[]) => void;
  onExport: () => void;
};

export const JournalEntriesReportToolbar: React.FC<Props> = ({
  month,
  onMonthChange,
  customerSearch,
  onCustomerSearchChange,
  filters,
  onFiltersChange,
  onExport,
}) => {
  return (
    <Box
      sx={{
        px: 2,
        pb: 2,
        display: "flex",
        alignItems: "flex-end",
        flexWrap: "wrap",
        gap: 2
      }}>
      <Box
        sx={[{
          display: "flex",
          flexDirection: "column"
        }, ...(Array.isArray(reportSearchContainerSx) ? reportSearchContainerSx : [reportSearchContainerSx])]}>
        <VyTableToolbar.SearchInput
          showLabel={false}
          onChange={(event) => onCustomerSearchChange(event.target.value)}
          defaultValue={customerSearch}
          placeholder="Search customer"
          sx={reportSearchInputSx}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flexShrink: 0
        }}>
        <VyDatePicker
          value={month}
          onChange={onMonthChange ?? noop}
          views={['month', 'year']}
          openTo="month"
          format="MMM YYYY"
          disableManualInput
          slotProps={reportDatePickerSlotProps}
        />
      </Box>
      <Box sx={reportFilterButtonWrapperSx}>
        <VyTableFilter
          fields={JOURNAL_ENTRIES_FILTER_FIELDS}
          defaultFilters={filters}
          onFiltersChange={onFiltersChange}
        />
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          minWidth: 16
        }} />
      <IconButton onClick={onExport} sx={reportIconButtonSx}>
        <VyIcon icon="Download" style={{ transform: 'scale(0.65)' }} />
      </IconButton>
    </Box>
  );
};
